<template lang="pug">
  .form-lesson-access
    .columns
      .column.is-4-tablet.is-4-desktop
        b-switch(v-model="availableToEveryone") Доступен всем

    .columns.is-multiline
      .column.is-4-tablet.is-4-desktop
        .field(v-for="role in rolesWithAccess.items" :key="role.id")
          b-tag(type="is-primary" size="is-medium" closable @close="revokeRoleAccess(role)") {{role.title}}
    .columns
      .column.is-4-tablet.is-4-desktop
        b-select(placeholder="Добавить группу пользователей" @input="giveAccessToRole")
          option(
            v-for="role in roles.items"
            :key="role.id"
            :value="role.id"
          ) {{role.title}}


    .columns.is-multiline
      .column.is-4-tablet.is-4-desktop
        .field(v-for="user in usersWithAccess.items" :key="user.id")
          b-tag(type="is-primary" size="is-medium" closable @close="revokeUserAccess(user)") {{user.fullName}}
    .columns
      .column.is-4-tablet.is-4-desktop
        b-select(placeholder="Добавить пользователя" @input="giveAccessToUser")
          option(
          v-for="user in users.items"
          :key="user.id"
          :value="user.id"
          ) {{user.fullName}}
</template>

<script>
import api from '@/api';
import UserGroup from '@/models/UserGroup';
import User from '@/models/User';

/**
 * @TODO remove duplication !!!
 * я пока не придумал, как это сделать, т. к. передавать имя класса через props не получается
 * @TODO не просить все роли и всех пользователей разом
 * @TODO сбрасывать select'ы после выбора
 */

export default {
  name: 'form-resource-access',

  props: {
    value: null,
    errors: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      availableToEveryone: false,
      rolesWithAccess: UserGroup.collection(),
      usersWithAccess: User.collection(),
      roles: UserGroup.collection(),
      users: User.collection(),
    };
  },

  created() {
    // api
    //   .for(`${this.value.$name}/${this.value.id}/list-access/${this.rolesWithAccess.$name}`)
    //   .fetch()
    //   .then(({ data }) => {
    //     this.rolesWithAccess = UserGroup.collection(data);
    //   });
    // api
    //   .for(`${this.value.$name}/${this.value.id}/list-access/${this.usersWithAccess.$name}`)
    //   .fetch()
    //   .then(({ data }) => {
    //     this.usersWithAccess = User.collection(data);
    //   });
    // api
    //   .for('roles/not-admins')
    //   .fetch()
    //   .then(({ data }) => {
    //     this.roles = UserGroup.collection(data);
    //   });
    // api
    //   .for('users/not-admins')
    //   .fetch()
    //   .then(({ data }) => {
    //     this.users = User.collection(data);
    //   });
    // api
    //   .for(`${this.value.$name}/${this.value.id}/check-access/by-everyone`)
    //   .fetch()
    //   .then(({ data }) => {
    //     this.availableToEveryone = data;
    //   });
  },

  methods: {
    async revokeRoleAccess(role) {
      // await api
      //   .for(
      //     `${this.value.$name}/${this.value.id}/revoke-access/${this.rolesWithAccess.$name}/${role.id}`
      //   )
      //   .delete();
      // this.rolesWithAccess.remove(role.id);
    },

    async revokeUserAccess(user) {
      // await api
      //   .for(
      //     `${this.value.$name}/${this.value.id}/revoke-access/${this.usersWithAccess.$name}/${user.id}`
      //   )
      //   .delete();
      // this.usersWithAccess.remove(user.id);
    },

    async giveAccessToRole(roleId) {
      const role = this.roles.find(roleId);

      if (!role) {
        return;
      }

      await api
        .for(
          `${this.value.$name}/${this.value.id}/give-access/${this.rolesWithAccess.$name}/${roleId}`
        )
        .create();

      this.rolesWithAccess.add(role);
    },

    async giveAccessToUser(userId) {
      const user = this.users.find(userId);

      if (!user) {
        return;
      }

      await api;
      // .for(
      //   `${this.value.$name}/${this.value.id}/give-access/${this.usersWithAccess.$name}/${userId}`
      // )
      // .create();

      this.usersWithAccess.add(user);
    },
  },

  watch: {
    async availableToEveryone(value) {
      // if (value) {
      //   await api.for(`${this.value.$name}/${this.value.id}/give-access/to-everyone`).create();
      //   this.availableToEveryone = true;
      // } else {
      //   await api.for(`${this.value.$name}/${this.value.id}/revoke-access/by-everyone`).delete();
      //   this.availableToEveryone = false;
      // }
    },
  },
};
</script>
